/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Preprocessing_DescriptionInputs */

const en_ocr_preprocessing_description = /** @type {(inputs: Ocr_Preprocessing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converts to grayscale, increases contrast, sharpens text, and upscales the image. Recommended for most videos.`)
};

const fr_ocr_preprocessing_description = /** @type {(inputs: Ocr_Preprocessing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertit en niveaux de gris, augmente le contraste, améliore la netteté du texte et agrandit l'image. Recommandé pour la plupart des vidéos.`)
};

const de_ocr_preprocessing_description = /** @type {(inputs: Ocr_Preprocessing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konvertiert in Graustufen, erhöht den Kontrast, schärft Text und skaliert das Bild hoch. Empfohlen für die meisten Videos.`)
};

const it_ocr_preprocessing_description = /** @type {(inputs: Ocr_Preprocessing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converte in scala di grigi, aumenta il contrasto, rende il testo più nitido e ingrandisce l'immagine. Consigliato per la maggior parte dei video.`)
};

const ru_ocr_preprocessing_description = /** @type {(inputs: Ocr_Preprocessing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преобразует изображение в оттенки серого, повышает контрастность, делает текст более четким и увеличивает масштаб изображения. Рекомендуется для большинства видеороликов.`)
};

const es_ocr_preprocessing_description = /** @type {(inputs: Ocr_Preprocessing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte a escala de grises, aumenta el contraste, mejora la nitidez del texto y amplía la imagen. Recomendado para la mayoría de los vídeos.`)
};

const zh_cn2_ocr_preprocessing_description = /** @type {(inputs: Ocr_Preprocessing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转换为灰度图像，增强对比度，锐化文本，并放大图像。推荐用于大多数视频。`)
};

const ja_ocr_preprocessing_description = /** @type {(inputs: Ocr_Preprocessing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グレースケールに変換し、コントラストを高め、テキストを鮮明にし、画像を拡大します。ほとんどの動画におすすめです。`)
};

const hi_ocr_preprocessing_description = /** @type {(inputs: Ocr_Preprocessing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह इमेज को ग्रेस्केल में बदलता है, कॉन्ट्रास्ट बढ़ाता है, टेक्स्ट को शार्प करता है और इमेज का साइज़ बढ़ाता है। ज़्यादातर वीडियो के लिए यह उपयुक्त है।`)
};

const pt_pt2_ocr_preprocessing_description = /** @type {(inputs: Ocr_Preprocessing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converte para tons de cinza, aumenta o contraste, melhora a nitidez do texto e amplia a imagem. Recomendado para a maioria dos vídeos.`)
};

/**
* | output |
* | --- |
* | "Converts to grayscale, increases contrast, sharpens text, and upscales the image. Recommended for most videos." |
*
* @param {Ocr_Preprocessing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_preprocessing_description = /** @type {((inputs?: Ocr_Preprocessing_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Preprocessing_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_preprocessing_description(inputs)
	if (locale === "de") return de_ocr_preprocessing_description(inputs)
	if (locale === "it") return it_ocr_preprocessing_description(inputs)
	if (locale === "ru") return ru_ocr_preprocessing_description(inputs)
	if (locale === "es") return es_ocr_preprocessing_description(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_preprocessing_description(inputs)
	if (locale === "ja") return ja_ocr_preprocessing_description(inputs)
	if (locale === "hi") return hi_ocr_preprocessing_description(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_preprocessing_description(inputs)
	return en_ocr_preprocessing_description(inputs)
});